module.exports = __webpack_public_path__ + "img/landing_box04.aeb8b0f6.jpg";